import script from "./ScheduleNotificationsManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleNotificationsManagement.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleNotificationsManagement.vue?vue&type=style&index=0&id=5bbc4dcb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bbc4dcb"]])

export default __exports__